// 多言語対応切り替え処理
export function pickText(lang: 'ja' | 'en', textJa: string, textEn: string): string {
  return lang === 'en' ? textEn : textJa;
}
